'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ExpiryDate.scss');

var ExpiryDate = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ExpiryDate, _PureComponent);

  function ExpiryDate() {
    (0, _classCallCheck3.default)(this, ExpiryDate);
    return (0, _possibleConstructorReturn3.default)(this, (ExpiryDate.__proto__ || (0, _getPrototypeOf2.default)(ExpiryDate)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExpiryDate, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          dateText = _props.dateText,
          isExpired = _props.isExpired;


      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)(styles.date, className, (0, _defineProperty3.default)({}, styles.isExpired, isExpired)) },
        dateText
      );
    }
  }]);
  return ExpiryDate;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  dateText: _propTypes2.default.string,
  isExpired: _propTypes2.default.bool
}, _class.defaultProps = {
  isExpired: false
}, _temp);
exports.default = ExpiryDate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpiryDate/ExpiryDate.js
// module id = 822
// module chunks = 1